import React, { useState } from "react";
import "../assets/css/SearchCustomer.css";
import axios from "axios";
import { toast } from "react-toastify";

const SearchCustomer = () => {
    const [searchId, setSearchId] = useState("");

    const [customer, setCustomer] = useState(null);
    const [loans, setLoans] = useState([]);
    const [savings, setSavings] = useState([]);
    const [deposits, setDeposits] = useState([]);

    const [customerError, setCustomerError] = useState("");
    const [loanError, setLoanError] = useState("");
    const [savingError, setSavingError] = useState("");
    const [depositError, setDepositError] = useState("");

    const [loading, setLoading] = useState(false);

    const branchId = localStorage.getItem("userId");

    /* ================= FETCH FUNCTIONS ================= */

    // Customer Details (SEARCH ID BASED)
    const fetchCustomerDetails = async (customerId) => {
        try {
             console.log("customer id",customerId)
            setCustomerError("");
            const res = await axios.get(
                "https://payyug.in/api/customers",
                {
                    params: {
                        branchId,
                        userId: customerId   // 👈 searched ID
                    }
                }
            );
            console.log("selected customer daa",res.data.data)
            setCustomer(res.data?.data || null);
        } catch (err) {
            setCustomer(null);
            setCustomerError("Customer details not found");
        }
    };

    // Loan Accounts
    const fetchLoanAccounts = async (customerId) => {
        try {
            setLoanError("");
            const res = await axios.get(
                "https://payyug.in/api/customers/loans",
                {
                    params: {
                        branchId,
                        customerId
                    }
                }
            );
            setLoans(res.data?.data || []);
        } catch (err) {
            setLoans([]);
            setLoanError("Loan accounts not available");
        }
    };

    // Saving Accounts
    const fetchSavingAccounts = async (customerId) => {
        try {
            setSavingError("");
            const res = await axios.get(
                "https://payyug.in/api/customers/savings",
                {
                    params: {
                        branchId,
                        customerId
                    }
                }
            );
            setSavings(res.data?.data || []);
        } catch (err) {
            setSavings([]);
            setSavingError("Saving accounts not available");
        }
    };

    //  Deposit Accounts
    const fetchDepositAccounts = async (customerId) => {
        try {
            setDepositError("");
            const res = await axios.get(
                "https://payyug.in/api/customers/deposits",
                {
                    params: {
                        branchId,
                        customerId
                    }
                }
            );
            setDeposits(res.data?.data || []);
        } catch (err) {
            setDeposits([]);
            setDepositError("Deposit accounts not available");
        }
    };

    /* ================= SEARCH HANDLER ================= */

    const handleSearch = async (e) => {
        e.preventDefault();
        if (!searchId.trim()) return toast.warn("Type any ID");

        setLoading(true);

        // 🔥 reset old data
        setCustomer(null);
        setLoans([]);
        setSavings([]);
        setDeposits([]);

        setCustomerError("");
        setLoanError("");
        setSavingError("");
        setDepositError("");

        // SAME SEARCH ID FOR ALL APIs
        await fetchCustomerDetails(searchId);
        await fetchLoanAccounts(searchId);
        await fetchSavingAccounts(searchId);
        await fetchDepositAccounts(searchId);

        setLoading(false);
    };

    return (
        <div className="search-customer-container">

            {/* SEARCH */}
            <form className="search-customer-filter" onSubmit={handleSearch}>
                <div className="search-customer-heading">Search Customer</div>
                <div className="search-customer-filter-input-fields">
                    <input
                        type="search"
                        placeholder="Enter Customer ID"
                        value={searchId}
                        onChange={(e) => setSearchId(e.target.value)}
                    />
                    <button type="submit">
                        {loading ? "Searching..." : "Search"}
                    </button>
                </div>
            </form>

            {/* CUSTOMER DETAILS */}
            <div className="searched-customer-container">
                <h2>Customer Details</h2>
                {customerError && <p>{customerError}</p>}

                {customer && (
                    <div className="searched-customer-details">
                        <div className="searched-customer-image">
                            <img
                                src={customer.photo || "/user.png"}
                                alt="customer"
                            />
                        </div>
                        <div className="searched-customer-info">
                            <table>
                                <tbody>
                                    <tr><th>Attribute</th><th>Value</th></tr>
                                    <tr><td>Customer ID</td><td>{customer.customerId}</td></tr>
                                    <tr><td>Name</td><td>{customer.name}</td></tr>
                                    <tr><td>Mobile</td><td>{customer.mobile}</td></tr>
                                    <tr><td>Email</td><td>{customer.email}</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>

            {/* LOAN ACCOUNTS */}
            <div className="searched-customer-container">
                <h2>Loan Accounts</h2>
                {loanError && <p>{loanError}</p>}
                {loans.length > 0 && (
                    <div className="searched-customer-info">
                        <table>
                            <tbody>
                                {loans.map((loan, index) => (
                                    <tr key={index}>
                                        <td>{loan.loanType}</td>
                                        <td>{loan.amount}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* SAVING ACCOUNTS */}
            <div className="searched-customer-container">
                <h2>Saving Accounts</h2>
                {savingError && <p>{savingError}</p>}
                {savings.length > 0 && (
                    <div className="searched-customer-info">
                        <table>
                            <tbody>
                                {savings.map((acc, index) => (
                                    <tr key={index}>
                                        <td>{acc.accountNo}</td>
                                        <td>{acc.balance}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* DEPOSIT ACCOUNTS */}
            <div className="searched-customer-container">
                <h2>Deposit Accounts</h2>
                {depositError && <p>{depositError}</p>}
                {deposits.length > 0 && (
                    <div className="searched-customer-info">
                        <table>
                            <tbody>
                                {deposits.map((dep, index) => (
                                    <tr key={index}>
                                        <td>{dep.depositType}</td>
                                        <td>{dep.amount}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

        </div>
    );
};

export default SearchCustomer;
